import { Trans, useTranslation } from "@equiem/web-ng-lib";
import { Site } from "@equiem/web-ng-lib";
import { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Comment } from "../icons/Comment";
import { RoundButton } from "../RoundButton";

export const CommentButton: React.FC = () => {
  const { t } = useTranslation();

  const [showRegisterNow, setShowRegisterNow] = useState(false);
  const { name: siteName } = useContext(Site);

  return (
    <>
      <RoundButton
        className="btn-comment ml-2 mb-2 disabled"
        shadow="always"
        loading={false}
        value={false}
        onToggle={async () => {
          setShowRegisterNow(true);
        }}
      >
        <Comment size={22} />
      </RoundButton>
      <Modal
        show={showRegisterNow}
        onHide={() => {
          setShowRegisterNow(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("main.comment")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Trans i18nKey="main.partOfCommunityCommentRegisterNow" values={{ siteName }} components={[<></>, <></>, <></>, <a href="/api/login?screen_hint=signup&utm_medium=sc" />]} />
        </Modal.Body>
      </Modal>
    </>
  );
};
